import Vue from 'vue'
import { RunWorkH5, SSDPDtgw, jssdk, SSDPApp } from '@runwork/runwork-help'
import axios from 'axios'
function initBy3(devUser) {
  Vue.use(RunWorkH5, {
    env: process.env.VUE_APP_env,
    isLocal: process.env.NODE_ENV === 'development',
    appId: process.env.VUE_APP_appId,
    devUser,
    isHrInfo: true
  })
  Vue.prototype.user = {}
  Vue.prototype.$nativeBridgeReady = () => {
    return Vue.prototype.$runWorkH5
      .initReady()
      .then(() => {
        if (!Vue.prototype.user.ldap) {
          Vue.prototype.user.ldap = Vue.prototype.$runWorkH5.ldap
          Vue.prototype.user.hrInfo = Vue.prototype.$runWorkH5.hrInfo
        }
        return true
      })
      .catch(e => {
        Vue.prototype.$Dialog({
          title: '异常提示',
          text: '信息同步失败，请稍后重试',
          onHandle: () => {
            window.tt.closeWindow({});
          }
        })
        return Promise.reject(e)
      })
  }
  Vue.prototype.ssdpRequestDtgw = Vue.prototype.$runWorkH5.ssdpRequestDtgw
  Vue.prototype.ssdpRequestDtgw1 = Vue.prototype.$runWorkH5.ssdpRequestDtgw

}

function initBy2() {
  console.log('2.0初始化')
  crhReady(() => {
    let promiseList = ['getCurrentUserInfo', 'getAppInfo', 'getDeviceInfo'].map(
      item => {
        return new Promise(resolve => {
          crh[item]({
            success: data => {
              resolve(data)
            }
          })
        })
      }
    )
    Promise.all(promiseList).then(([user, run, device]) => {
      console.log('2.0初始化完成', user, run, device)
      Object.assign(Vue.prototype, {
        user,
        run,
        device,
        bridgeReady: true
      })
      Vue.prototype.user.ldap = user.userId
      Vue.prototype.user.hrInfo = user.hrInfo
    })
      .catch((err) => {
        console.log(err);
        console.log('2.0初始化失败');
      })
  })

  Vue.prototype.$nativeBridgeReady = () => {
    if (Vue.prototype.bridgeReady) {
      return Promise.resolve()
    }
    let job,
      count = 0
    return new Promise((resolve, reject) => {
      job = setInterval(() => {
        ++count
        if (Vue.prototype.bridgeReady) {
          clearInterval(job)
          count = 0
          resolve()
        } else if (count > 30) {
          clearInterval(job)
          reject('获取基础数据失败')
        }
      }, 200)
    })
  }
  let ssdpDtgw = new SSDPDtgw(process.env.VUE_APP_env)
  Vue.prototype.ssdpRequestDtgw = ({
    code,
    headers = {},
    data,
    onProgress,
    responseType = 'json'
  } = {}) => {
    return ssdpDtgw.request({
      code,
      headers,
      responseType,
      data,
      onProgress
    })
  }
  Vue.prototype.ssdpRequestDtgw1 = Vue.prototype.$runWorkH5.ssdpRequestDtgw

}

async function initBy1() {
  Vue.prototype.user = {}
  let proAppId = {
    App_Sub_ID: "0000000401RH",
    App_Token: "2bbc84f3bde54df488b4b0133989956c",
    App_key: "8c33a5babafd4f1197a6880a960ab91b",
    Partner_ID: "00000000",
  }
  let uatAppId = {
    App_Sub_ID: "0000000309OK",
    App_Token: "5643f1d9d86c43c9ae72069c243dbf86",
    App_key: "52e219166c7c41a68b490ac4efc22fa2",
    Partner_ID: "00000000"
  }
  let appId = process.env['VUE_APP_H5_ENV'] === 'production' ? proAppId : uatAppId
  let ssdpDtgw = new SSDPApp({
    App_ID: "xxx",
    App_Version: "xxx",
    Divice_ID: "xxx",
    Divice_Version: "xxx",
    OS_Version: "xxx",
    User_Token: "xxx",
    ...appId
  }, process.env['VUE_APP_H5_ENV'] === 'production' ? "production" : "test")
  Vue.prototype.$nativeBridgeReady = () => {
    return ssdpDtgw.init()
  }
  Vue.prototype.ssdpRequestDtgw = ssdpDtgw
  Vue.prototype.ssdpRequestDtgw1 = ({
    code,
    headers = {},
    data = {},
    onProgress,
    responseType = 'json',
    isUpload = true,
    params = {}
  } = {}) => {
    headers = { ...(isUpload ? JSON.parse(process.env['VUE_APP_H5_HEADER']) : JSON.parse(process.env['VUE_APP_H5_downLoadHeader'])), ...headers, 's-crc-ds-codes': code }
    return axios({
      url: process.env['VUE_APP_H5_URL'],
      method: 'post',
      headers,
      responseType,
      data,
      params,
      onProgress
    })
  }
}
export default function init(devUser) {
  let platform = 1
  if (!!window.h5sdk || process.env.NODE_ENV === "development") {
    platform = 3
  } else {
    if (Vue.prototype.isRunwork) {
      platform = 2
    } else {
      platform = 1
    }
  }
  switch (platform) {
    case 1:
      initBy1()
      break
    case 2:
      initBy2()
      break
    case 3:
      initBy3(devUser)
      break
  }
  return true
  // return platform().then(pf => {
  //   console.log('获取到平台', pf)
  //   Vue.prototype.platform = pf
  //   switch (pf) {
  //     case 2:
  //       initBy2()
  //       break
  //     case 3:
  //       initBy3(devUser)
  //       break
  //   }
  //   return true
  // })
}
